// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"_1j2KM"};